import { createFileRoute } from "@tanstack/react-router";
import { ProgrammeScreen } from "@modules/appels/views";

export const Route = createFileRoute(
  "/_staff-area/cohorts/$cohortId/appels/$appelId/programme"
)({
  staticData: { title: "nav.cohorts" },
  component: ProgrammeRoute,
});

function ProgrammeRoute() {
  const { appelId } = Route.useParams();
  return <ProgrammeScreen appelId={appelId} />;
}
